import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideBar from "../../components/SideBar";
import { ReportParamsContext } from "../../context/ReportParamsContext";
import ReportParametersSelector from "../../components/ReportParametersSelector";

const ROUTES_WITHOUT_PARAMS = ["task_report"];

export default function ReportsLayout({ sideBarItems }) {
  const location = useLocation();
  const hideParams = ROUTES_WITHOUT_PARAMS.some((r) => location.pathname.endsWith(r));
  const [searchText, setSearchText] = useState("");
  const [commonParams, setCommonParams] = useState({
    manufacturer: null,
    fromDate: "",
    toDate: "",
    provinces: [],
    territories: [],
    representatives: [],
    itemStatus: "ACTIVE",
  });

  return (
    <>
      <SideBar items={sideBarItems} />
      <ReportParamsContext.Provider value={[commonParams, setCommonParams]}>
        <div className="d-flex flex-column flex-grow-1 overflow-hidden">
          {!hideParams && <ReportParametersSelector />}
          <Outlet context={[searchText, setSearchText]} />
        </div>
      </ReportParamsContext.Provider>
    </>
  );
}
